<nav id="header-menu" class="header-menu" aria-label="Menu">
  <ul class="header-menu__list">
    @for (item of items; track item.label) {
      <li>
        <a [routerLink]="item.route" [title]="item.title ?? item.label" (click)="closed.emit()">
          {{ item.label }}
        </a>
        @if (item.children) {
          <ul class="header-menu__submenu">
            @for (child of item.children; track child.label) {
              <li>
                @if (child.route) {
                  <a [routerLink]="child.route" (click)="closed.emit()">{{ child.label }}</a>
                } @else {
                  <a [href]="child.href" target="_blank" rel="noopener" (click)="closed.emit()">
                    {{ child.label }}
                  </a>
                }
              </li>
            }
          </ul>
        }
      </li>
    }
    <li>
      <a [href]="clientAreaUrl" title="Área do cliente" (click)="closed.emit()">Área do cliente</a>
    </li>
  </ul>
</nav>
